import { DynamischeStundenbewertung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Abwesenheiten/DynamischeStundenbewertung';
import { Guttage } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung/Abwesenheiten/Guttage';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  DataDisplayPlain,
  Heading,
  Separator,
  Title,
} from '@e2n/ui/v2';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line max-lines-per-function
export function Abwesenheiten() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  const feiertagValues: string[] = [];

  if (
    data.abwesenheiten.feiertagseinstellungen.feiertagsausgleich ===
    'ZUSCHLAEGE'
  ) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.zuschlagsregelungGreift',
      ),
    );
  }
  if (
    data.abwesenheiten.feiertagseinstellungen.feiertagsausgleich ===
    'STUNDENGUTSCHRIFT'
  ) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.stundenGutschreibung',
      ),
    );
  }
  if (
    data.abwesenheiten.feiertagseinstellungen.feiertagsdynamik ===
    'AUF_SOLL_AUFFUELLEN'
  ) {
    feiertagValues.push(
      t(
        'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.options.taeglicheArbeitszeitAuffuellen',
      ),
    );
  }

  return (
    <AccordionItem value="abwesenheiten">
      <AccordionTrigger>
        <Heading className="ml-2">
          {t('domain.mitarbeiter.create.steps.abwesenheiten.title')}
        </Heading>
      </AccordionTrigger>
      <AccordionContent>
        <div className="py-4 flex flex-col gap-2">
          <div className="flex items-center">
            <Title>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.label',
              )}
            </Title>
            <Button
              className="ml-auto"
              iconOnly
              variant={'secondary-red'}
              onClick={() => ctx.navigateToSubStep('abwesenheiten.allgemein')}>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          <div className="flex flex-col gap-4">
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.zusammenfassung.label',
              )}
              item={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.anzahlUrlaubstage.zusammenfassung.text',
                {
                  anzahl: data.abwesenheiten.allgemein.anzahlUrlaubstage,
                },
              )}
            />
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.zusammenfassung.label',
              )}
              item={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.arbeitstage.options.' +
                  data.abwesenheiten.allgemein.anzahlArbeitstage,
              )}
            />
            <DataDisplayPlain
              orientation="horizontal"
              variant="text"
              label={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.zusammenfassung.label',
              )}
              item={t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.zusammenfassung.options.' +
                  data.abwesenheiten.allgemein.stundenBewertung,
              )}
            />

            {data.abwesenheiten.allgemein.stundenBewertung === 'fest' ? (
              <DataDisplayPlain
                orientation="horizontal"
                variant="text"
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
                )}
                item={`${data.abwesenheiten.allgemein.stunden} ${t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.suffix',
                )}`}
              />
            ) : (
              <DynamischeStundenbewertung />
            )}
          </div>
        </div>
        <Guttage />
        <Separator />
        <div className="py-4 flex flex-col gap-2">
          <div className="flex items-center">
            <Title>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.label',
              )}
            </Title>
            <Button
              className="ml-auto"
              iconOnly
              variant={'secondary-red'}
              onClick={() =>
                ctx.navigateToSubStep('abwesenheiten.feiertagseinstellungen')
              }>
              <FontAwesomeIcon icon={faPen} />
            </Button>
          </div>
          <DataDisplayPlain
            orientation="horizontal"
            variant="text"
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.feiertagseinstellungen.zusammenfassung.label',
            )}
            item={feiertagValues.length > 0 ? feiertagValues.join(', ') : '-'}
          />
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
